// extracted by mini-css-extract-plugin
module.exports = {"chooser-label":"_3aFiu","chooserLabel":"_3aFiu"};